"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveInitialFieldValue = void 0;

var _useTextField = require("../fields/useTextField");

var _useSelectField = require("../fields/useSelectField");

var _useNumberField = require("../fields/useNumberField");

var _useBooleanField = require("../fields/useBooleanField");

var _useListField = require("../fields/useListField");

var _useObjectField = require("../fields/useObjectField");

var defaultValues = {
  text: _useTextField.defaultTextValue,
  select: _useSelectField.defaultSelectValue,
  number: _useNumberField.defaultNumberValue,
  boolean: _useBooleanField.defaultBooleanValue,
  list: _useListField.defaultListValue,
  object: _useObjectField.defaultObjectValue
};

var resolveInitialFieldValue = function resolveInitialFieldValue(fieldValue, initialValue) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';

  if (initialValue !== undefined) {
    return initialValue;
  }

  if (fieldValue !== undefined) {
    return fieldValue;
  }

  var defaultValue = defaultValues[type];
  return defaultValue !== undefined ? defaultValue : _useTextField.defaultTextValue;
};

exports.resolveInitialFieldValue = resolveInitialFieldValue;